<template>
  <div class="cb-body__wrap">
    <div class="cb-body__content">
      <div
        v-if="paymentIcon"
        class="cb-section cb-section__center cb-mar--b-xl cb-mar--t-xl"
      >
        <div :class="paymentIcon" aria-hidden="true"></div>
      </div>

      <div class="cb-section cb-section__center">
        <div class="cb-section__title cb-section__title--nospacing">
          {{
            cmt("payment_loader.content.title", { amount: this.amount })
          }}
        </div>
      </div>

      <div v-if="pmType" class="cb-section cb-section__center">
        <div class="cb-fw--normal cb-fs--st">
          {{ cmt("payment_loader.content." + this.pmType) }}
        </div>
      </div>

      <div class="cb-section cb-section__center cb-mar--b-xxl cb-mar--t-xxl">
        <div class="cb-fw--normal cb-fs--st">
          {{ cmt("payment_loader.timer.text") }}
        </div>
        <div class="cb-fs--xxl cb-pad--t-md cb-pad--b-xxl">
          {{ formatedTime }}
        </div>
      </div>

      <div class="cb-section cb-section__help cb-section__center">
        {{ cmt("payment_loader.disclaimer") }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      timeLimit: 300,
      timeLeft: 300,
      interval: null,
    };
  },
  mounted() {
		if(!this.payment_intent) {
			this.$router.go(-1)
		}
    this.startTimer();
  },
  destroyed() {
    this.clearIntervals();
  },
  methods: {
    startTimer() {
      this.clearIntervals();
      this.interval = setInterval(() => {
        this.timeLeft = this.timeLeft - 1;
        if (this.timeLeft == 0) {
          this.clearIntervals();
        }
      }, 1000);
    },
    clearIntervals() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  },
  computed: {
    ...mapGetters(["payment_intent"]),
    amount() {
      return this.$options.filters.cbCurrency(
        this.payment_intent.amount,
        this.payment_intent.currency_code
      );
    },
    pmType() {
      return this.payment_intent.payment_method_type;
    },
    paymentIcon() {
      if (this.pmType == "pay_to") {
        return "cb-icon icon-payto icon-payto--large";
      }
      return "cb-icon";
    },
    formatedTime() {
      let minutes = Math.floor(this.timeLeft / 60);
      let seconds = this.timeLeft % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${minutes}:${seconds}`;
    },
  },
};
</script>